import { EventEmitter, Injectable, Output, OnDestroy } from "@angular/core";
import { AuthHelper } from "../components/auth/auth-helper";
import { Subscription } from "rxjs/internal/Subscription";
import { HttpClient } from "@angular/common/http";
import { AuthRoute } from "../components/auth/auth.route";
import { AuthConfig } from "../components/auth/auth.config";

@Injectable({
  providedIn: "root"
})
export class ConfigService implements OnDestroy {
  configuration: any = {};
  emitter = new EventEmitter<any>();
  jwtHelper = new AuthHelper();
  minDate = new Date("1900-01-01T00:00:00Z");
  maxDate = new Date("2099-12-31T00:00:00Z");
  dateFormat = "dd/mm/yyyy";
  appNameKey = "appName";

  private _jsonSubscription: Subscription;

  @Output() onShowFilter = new EventEmitter();

  /*
   configuracion global para poder activa o desactivar opciones y poder controlar los comportamientos
   de los servicios y clases de la librerÃ­a
  */
  GlobalOptions = {
    /*
    @blocker: opciones del blocker */
    blocker: {
      /*
    @turnOff: boolean = false; apaga el blockUI y evita que emita durante toda la ejecucion del SPA
     */
      turnOff: false,
      /*
    @turnOffOnce: boolean = false; esta variable se valida cada vez que se dispara el bloquer. Si es true y blocker.turnOff = false
    entones el bloque no se dispararÃ¡ en esa sola ocasiÃ³n una vez evaluada volvera a ser false
     */
      turnOffOnce: false,
      /*
    @active: boolean = false; Indica si el blocker esta activo o no
     */
      active: false
    }
  };

  constructor(private _http: HttpClient) {}

  set blocker(value: boolean) {
    /*@para evitar emitir dos veces el mismo estado*/
    if (this.GlobalOptions.blocker.active === value) {
      return;
    }

    this.GlobalOptions.blocker.active = value;

    if (this.GlobalOptions.blocker.turnOff) {
      return;
    }

    if (this.GlobalOptions.blocker.turnOffOnce) {
      this.GlobalOptions.blocker.turnOffOnce = false;
      return;
    }

    this.emitter.emit({ BlockUI: this.GlobalOptions.blocker.active });
  }

  get blocker() {
    return (
      this.GlobalOptions.blocker.active &&
      !this.GlobalOptions.blocker.turnOff &&
      this.GlobalOptions.blocker.turnOffOnce
    );
  }

  load(url: string): Promise<any> {
    return new Promise(resolve => {
      this._jsonSubscription = this._http.get(url).subscribe(
        conf => {
          this.configuration = conf;

          const appName = localStorage.getItem(this.appNameKey);

          if (appName && appName != "") {
            this.setActiveConfiguration(appName);
          }

          if (!this.configuration) {
            this.configuration = {
              config: {}
            };
          }

          this.configuration.config.AuthRoute = new AuthRoute(
            this.configuration.config.AuthRoute
          );

          this.configuration.config.AuthConfig = new AuthConfig(
            this.configuration.config.AuthConfig
          );

          resolve();
        },
        error => {
          throw new Error(error);
        }
      );
    });
  }

  getUrlApi(segment?: string): string {
    try {
      const con = this.configuration.config;

      if (con) {
        const active = con.apps.find(val => val.key === con.active);

        if (active) {
          return `${active.api}${segment || ""}`;
        }
      }

      return "http://localhost/";
    } catch (e) {
      throw new Error("Error reading configuration file");
    }
  }

  disableGuard(): boolean {
    try {
      const con = this.configuration.config;

      if (con) {
        const active = con.apps.find(val => val.key === con.active);

        if (active) {
          return active.disableGuard;
        }
      }

      return false;
    } catch (e) {
      throw new Error("Error reading configuration file");
    }
  }

  getUrlReport(): string {
    try {
      const con = this.configuration.config;

      if (con) {
        const active = con.apps.find((val, i) => val.key === con.active);

        if (active) {
          return active.report;
        }
      }

      return "http://localhost/";
    } catch (e) {
      throw new Error("Error reading configuration file");
    }
  }

  setActiveConfiguration(key: string) {
    this.configuration.config.active = key;
  }

  getActiveConfiguration(): string {
    return this.configuration.config.active;
  }

  getConfigurationApps(): any[] {
    return this.configuration.config.apps;
  }

  getActiveAppName(): string {
    const con = this.configuration.config;

    if (con) {
      const active = con.apps.find((val, i) => val.key === con.active);

      if (active) {
        return active.name;
      }
    }

    throw new Error("Application active name not found");
  }

  getAuthRoute(): AuthRoute {
    return this.configuration.config.AuthRoute;
  }

  getAuthConfig(): AuthConfig {
    return this.configuration.config.AuthConfig;
  }

  hasAuthConfig() {
    try {
      this.getAuthConfig();
    } catch (e) {
      return false;
    }

    return true;
  }

  ngOnDestroy() {
    if (this._jsonSubscription) {
      this._jsonSubscription.unsubscribe();
    }
  }
}
